<template>
    <header class="header">
      <div class="header-left">
         <div class="user-menu" @click="toggleAuth">
            <svg v-if="!store.user.token" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
              <circle cx="12" cy="7" r="4"></circle>
            </svg>
            <div v-else class="user-logged" @click.stop="showUserMenu = !showUserMenu">
               <span class="user-initial">{{ store.user.info?.name?.charAt(0).toUpperCase() }}</span>
               <div v-if="showUserMenu" class="dropdown-menu">
                  <div class="menu-item">{{ store.user.info?.name }}</div>
                  <div class="menu-item logout" @click="store.logout()">{{ $t('logout') || 'Logout' }}</div>
               </div>
            </div>
         </div>
      </div>

      <img class="logo" src="../../public/logo.png" alt="" @click="goToCategory">

      <div class="lang-container">
        <LanguageSwitcher />
      </div>

      <AuthModal v-if="store.isAuthModalOpen" @close="store.isAuthModalOpen = false" />
    </header>
  </template>
  
  <script setup>
  import { ref } from 'vue'
  import { useRouter } from 'vue-router'
  import LanguageSwitcher from './LanguageSwitcher.vue'
  import AuthModal from './auth/AuthModal.vue'
  import store from '../store'

  const router = useRouter()
  const showUserMenu = ref(false)


  const goToCategory = () => {
    router.push('/')
  }

  const toggleAuth = () => {
    if (!store.user.token) {
      store.isAuthModalOpen = true
    }
  }
  </script>
  
  <style scoped>
    .header {
      height: 60px;
      width: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      background-color: white;
      backdrop-filter: blur(4px);
      box-shadow: 0 4px 20px rgba(0, 0, 0, 0.03);
      position: sticky;
      top: 0;
      z-index: 50;
    }
  
    .logo {
      width: 150px;
      min-width: 80px;
      cursor: pointer;
    }

    .lang-container {
      position: absolute;
      right: 20px;
      top: 50%;
      transform: translateY(-50%);
    }

    .header-left {
      position: absolute;
      left: 20px;
      top: 50%;
      transform: translateY(-50%);
    }

    .user-menu {
      cursor: pointer;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    .user-initial {
      width: 32px;
      height: 32px;
      background: #3b82f6;
      color: white;
      border-radius: 50%;
      display: flex;
      justify-content: center;
      align-items: center;
      font-weight: bold;
    }

    .dropdown-menu {
      position: absolute;
      top: 40px;
      left: 0;
      background: white;
      border: 1px solid #e2e8f0;
      border-radius: 8px;
      box-shadow: 0 4px 12px rgba(0,0,0,0.1);
      min-width: 120px;
      overflow: hidden;
    }

    .menu-item {
      padding: 10px 15px;
      font-size: 0.9rem;
      color: #1e293b;
      white-space: nowrap;
    }

    .menu-item.logout {
      border-top: 1px solid #f1f5f9;
      color: #ef4444;
      cursor: pointer;
    }

    .menu-item.logout:hover {
      background: #fef2f2;
    }
  </style>
